var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-box"},[_c('div',{staticClass:"content-home"},[_c('HomeSection1'),_c('HomeSection2'),_c('HomeSection3'),_c('HomeSection4'),_c('HomeSection5'),_c('HomeSection6')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }